import React, { Component } from "react";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import "./BaseUrl";
import "./Style.css";
import $ from "jquery";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

class CounterMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      counter_data: [],
      counter_details: [],
      counter_images: [],
      headingType: [],
      assets_url: global.AssetsUrl,
      my_id: [],
      base_url: global.BaseUrl,
    };
  }

  componentDidMount() {
    const { id } = this.props; // Receiving id as a prop

    $(document).ready(function () {
      $("ul.tabs li").click(function () {
        var tab_id = $(this).attr("data-tab");
        $("ul.tabs li").removeClass("current");
        $(".tab-content").removeClass("current");
        $(this).addClass("current");
        $("#" + tab_id).addClass("current");
      });
    });

    // Fetch counter details
    fetch(`${this.state.base_url}/getByMenu/${id}`)
      .then((resp) => resp.json())
      .then((result) => {
        console.log("Counter Details:", result.counter);
        this.setState({ counter_details: result.counter });
      })
      .catch((error) =>
        console.error("Error fetching counter details:", error),
      );

    // Fetch counter data
    fetch(`${this.state.base_url}/getByMenu/${id}`)
      .then((resp) => resp.json())
      .then((result) => {
        console.log("Counter Data:", result.counter_data);
        this.setState({ counter_data: result.counter_data });
      })
      .catch((error) => console.error("Error fetching counter data:", error));

    // Fetch heading type
    fetch(`${this.state.base_url}/getByMenu/${id}`)
      .then((resp) => resp.json())
      .then((result) => {
        console.log("Heading Type:", result.counter_data);
        this.setState({ headingType: result.counter_data });
      })
      .catch((error) => console.error("Error fetching heading type:", error));

    // Fetch counter images
    fetch(`${this.state.base_url}/getByMenu/${id}`)
      .then((resp) => resp.json())
      .then((result) => {
        console.log("Counter Images:", result.counter_images);
        this.setState({ counter_images: result.counter_images });
      })
      .catch((error) => console.error("Error fetching counter images:", error));
  }

  render() {
    const { counter_data, headingType, counter_details, counter_images } =
      this.state;

    return (
      <>
        <section className="about-us-session padding-top-100">
          <div className="container-fluid">
            {}
            <div className="row">
              <div className="col-md-3 col-12 counter_top_img">
                <img
                  src={`${this.state.assets_url}/uploads/${counter_details.counter_logo}`}
                  alt="Counter logo"
                  className="counter_top_content img img-responsive wow zoomIn"
                  style={{
                    visibility: "visible",
                    animationName: "zoomIn",
                    width: "100%",
                  }}
                />
              </div>

              {counter_images.map((image) => {
                return (
                  <div className="col-md-3 col-12  counter_top_img menu_img id35">
                    <img
                      src={`${this.state.assets_url}/uploads/${image}`}
                      alt
                      className="counter_top_content img img-responsive wow zoomIn counter_img"
                      style={{
                        visibility: "visible",
                        animationName: "zoomIn",
                        maxHeight: "212px !important",
                        width: "100%",
                      }}
                    />
                  </div>
                );
              })}

              <div className="col-md-3 col-12   ">
                {/* <p>Menu Indicator</p> */}
                <div
                  className="counter_top_content h316"
                  style={{
                    background: "#fff",
                    padding: "0px 10px 0px 10px",
                    border: "1px solid #48368e",
                    boxShadow: "0.5rem 1rem rgba(0,0,0,.15)!important",
                  }}
                >
                  <ui>
                    <div style={{ textAlign: "center" }}>
                      <b>Menu Indicator</b>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/vag.png" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Vegetarian Preparation
                      </span>
                    </div>
                    <div>
                      <span>
                        <img
                          src="../assets/images/icon/non-vag-new.png"
                          width="20px"
                        />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Non Vegetarian Preparation
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/0.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains cereals containing gluten
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/1.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains nuts
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/2.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains crustacean or their products
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/3.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains milk or their products
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/4.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains eggs or their products
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/5.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains fish or their products
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/6.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains groundnut, tree nut or their products
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/7.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains Soya or their products
                      </span>
                    </div>
                    <div>
                      <span>
                        <img src="../assets/images/icon/8.jpg" width="20px" />
                      </span>{" "}
                      <span style={{ fontSize: "12px", color: "#000" }}>
                        Contains sulphites in concentrations of 10mg/kg or more
                      </span>
                    </div>
                  </ui>
                </div>
              </div>
            </div>
          </div>
        </section>

        {headingType.map((heading) => {
          // console.log("hello" , heading.id);
          this.state.my_id = heading.id;
          return <h1></h1>;
        })}

        {this.state.my_id == 8 ? (
          <section
            className="container my_div padding-top-50"
            style={{ marginTop: "50px" }}
          >
            <div className="swin-sc swin-sc-title  light">
              <p className="top-title">
                <span>All Day</span>
              </p>
              <h3 className="title" style={{ color: "#000" }}>
                Weekly Special
              </h3>
            </div>
            {counter_data.map((mydata) => {
              const category_list = mydata.categories;
              return (
                <div className="text-left">
                  {category_list.map((supercat_name) => {
                    const sub_catategory = supercat_name.subcategories;

                    return (
                      <div style={{ /*padding: "10px",*/ marginTop: "20px" }}>
                        <h1 style={{ color: "gray", textAlign: "center" }}>
                          {supercat_name.supercatname}
                        </h1>
                        {sub_catategory.map((sub_cat) => {
                          const dishes = sub_cat.category_dishes;
                          return (
                            <div
                              style={{ background: "#fff", /* padding: "10px" */ }}
                            >
                              {/* <h3 className="sub_cat_heading">{sub_cat.subcatname}</h3> */}

                              {sub_cat.subcatname == "NA" ? (
                                <h3></h3>
                              ) : (
                                <h3 className="sub_cat_heading">
                                  {sub_cat.subcatname}
                                </h3>
                              )}
                              <div className="container">
                                <div className="row">
                                  {dishes.map((dish_list) => {
                                    return (
                                      <div
                                        className="col-lg-6 col-md-6"
                                        style={{ marginBottom: "20px" }}
                                      >
                                        <div className="swin-sc products-01 style-04 light swin-vetical-slider">
                                          
<div className="dish_row_wrap">
  {/* Row 1: veg/non-veg icon + dish name + indicators — always one line */}
  <div className="dish_main_row">
    <div className="dish_icon_fixed">
      {dish_list.dish_type == "Veg" ? (
        <img
          src="../assets/images/icon/vag.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      ) : (
        <img
          src="../assets/images/icon/non-vag-new.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      )}
    </div>

    <p
      className="dish_name dish_name_text"
      style={{
        marginRight: "5px",
        color: "black",
        fontWeight: "450",
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      {dish_list.dish_name}
    </p>

    <div className="dish_indicators_fixed">
      {dish_list.dish_indicator1 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator1}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator2 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator2}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator3 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator3}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
    </div>
  </div>

  {/* Price - stays top-right */}
  <p
    className="item-right dish_name text-center"
    style={{ marginBottom: "0px", flexShrink: 0 }}
  >
    {dish_list.dish_price == null ? null : (
      <span className="price woocommerce-Price-amount amount">
        ₹{dish_list.dish_price}
      </span>
    )}
  </p>

  {/* Row 2: kcal — goes below the name row (only wraps down on mobile) */}
  {(dish_list.dish_KiloCalories || dish_list.dish_ServingSize) && (
    <div className="dish_kcal_row">
      <div
        className="dish_kcal"
        style={{
          color: "#ffb300",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        (
        {dish_list.dish_KiloCalories && (
          <>{dish_list.dish_KiloCalories} Kcal</>
        )}
        {dish_list.dish_KiloCalories && dish_list.dish_ServingSize && " / "}
        {dish_list.dish_ServingSize && (
          <>
            {dish_list.dish_ServingSize}{" "}
            {dish_list.dish_ServedIn && dish_list.dish_ServedIn}
          </>
        )}
        )
      </div>
    </div>
  )}
</div>

                                        </div>
                                        {/* <div
                                          className="des"
                                          style={{ lineHeight: "0.1" }}
                                        >
                                          {dish_list.dish_description}
                                        </div> */}
                                        {/* {dish_list.dish_Calories == null ||
                                        dish_list.dish_Calories == "" ? null : (
                                          <div
                                            className="des"
                                            style={{
                                              lineHeight: "normal",
                                            }}
                                          >
                                            {dish_list.dish_Calories} Kcal
                                          </div>
                                        )} */}
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </section>
        ) : (
          <section
            className="my_div padding-top-50"
            style={{ marginTop: "50px" }}
          >
            <div className="swin-sc swin-sc-title text-center light ">
              <p className="top-title">
                <span>Weekly Change</span>
              </p>
              <h3 className="title" style={{ color: "#000" }}>
                Daily Special
              </h3>
            </div>

            <div className="container">
              <div className="row">
                <section className="about-us-session padding-top-100 padding-bottom-100 ">
                  <div className="container ">
                    <div style={{ justifyContent: "center", display: "flex" }}>
                      <ul className="tabs">
                        <li
                          className="tab-link tabs-btn current active swin-btn"
                          style={{ float: "left", marginLeft: "20px" }}
                          data-tab="Monday"
                        >
                          Monday
                        </li>
                        <li
                          className="tab-link tabs-btn swin-btn"
                          style={{ float: "left", marginLeft: "20px" }}
                          data-tab="Tuesday"
                        >
                          Tuesday
                        </li>
                        <li
                          className="tab-link tabs-btn swin-btn"
                          style={{ float: "left", marginLeft: "20px" }}
                          data-tab="Wednesday"
                        >
                          Wednesday
                        </li>
                        <li
                          className="tab-link tabs-btn swin-btn"
                          style={{ float: "left", marginLeft: "20px" }}
                          data-tab="Thursday"
                        >
                          Thursday
                        </li>
                        <li
                          className="tab-link tabs-btn swin-btn"
                          style={{ float: "left", marginLeft: "20px" }}
                          data-tab="Friday"
                        >
                          Friday
                        </li>
                        {/* <li className="tab-link tabs-btn swin-btn" style={{ float: 'left', marginLeft: '20px' }} data-tab="Saturday">Saturday</li> */}
                        {/*<li className="tab-link tabs-btn swin-btn" style={{float:'left',marginLeft:'20px'}} data-tab="Sunday">Sunday</li> */}
                      </ul>
                    </div>

                    <div id="Monday" className="tab-content current active kspl">
                      {counter_data
                        .filter((mydata) => mydata.name == "Monday")
                        .map((mydata) => {
                          const category_list = mydata.categories;
                          return (
                            <div className="text-left">
                              {category_list.map((supercat_name) => {
                                const sub_catategory =
                                  supercat_name.subcategories;

                                return (
                                  <div
                                    style={{
                                      // padding: "10px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <h1
                                      style={{
                                        color: "gray",
                                        textAlign: "center",
                                      }}
                                    >
                                      {supercat_name.supercatname}
                                    </h1>
                                    {sub_catategory.map((sub_cat) => {
                                      const dishes = sub_cat.category_dishes;
                                      return (
                                        <div
                                          style={{
                                            background: "#fff",
                                            // padding: "10px",
                                          }}
                                        >
                                          {/* <h3 className="sub_cat_heading">{sub_cat.subcatname}</h3> */}
                                          {sub_cat.subcatname == "NA" ? (
                                            <h3></h3>
                                          ) : (
                                            <h3 className="sub_cat_heading">
                                              {sub_cat.subcatname}
                                            </h3>
                                          )}
                                          <div className="container">
                                            <div className="row">
                                              {dishes
                                                .filter(
                                                  (dish_list) =>
                                                    dish_list.counter_heading ==
                                                    1,
                                                )
                                                .map((dish_list, index) => {
                                                  return (
                                                    <div
                                                      className="col-lg-6 col-md-6"
                                                      style={{
                                                        marginBottom: "20px",
                                                      }}
                                                    >
                                                      <div className="swin-sc products-01 style-04 light swin-vetical-slider">
                                                   
<div className="dish_row_wrap">
  {/* Row 1: veg/non-veg icon + dish name + indicators — always one line */}
  <div className="dish_main_row">
    <div className="dish_icon_fixed">
      {dish_list.dish_type == "Veg" ? (
        <img
          src="../assets/images/icon/vag.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      ) : (
        <img
          src="../assets/images/icon/non-vag-new.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      )}
    </div>

    <p
      className="dish_name dish_name_text"
      style={{
        marginRight: "5px",
        color: "black",
        fontWeight: "450",
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      {dish_list.dish_name}
    </p>

    <div className="dish_indicators_fixed">
      {dish_list.dish_indicator1 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator1}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator2 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator2}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator3 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator3}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
    </div>
  </div>

  {/* Price - stays top-right */}
  <p
    className="item-right dish_name text-center"
    style={{ marginBottom: "0px", flexShrink: 0 }}
  >
    {dish_list.dish_price == null ? null : (
      <span className="price woocommerce-Price-amount amount">
        ₹{dish_list.dish_price}
      </span>
    )}
  </p>

  {/* Row 2: kcal — goes below the name row (only wraps down on mobile) */}
  {(dish_list.dish_KiloCalories || dish_list.dish_ServingSize) && (
    <div className="dish_kcal_row">
      <div
        className="dish_kcal"
        style={{
          color: "#ffb300",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        (
        {dish_list.dish_KiloCalories && (
          <>{dish_list.dish_KiloCalories} Kcal</>
        )}
        {dish_list.dish_KiloCalories && dish_list.dish_ServingSize && " / "}
        {dish_list.dish_ServingSize && (
          <>
            {dish_list.dish_ServingSize}{" "}
            {dish_list.dish_ServedIn && dish_list.dish_ServedIn}
          </>
        )}
        )
      </div>
    </div>
  )}
</div>

                                                      </div>
                                                      
                                                      {/* <div
                                                        className="des"
                                                        style={{
                                                          lineHeight: "0.1",
                                                        }}
                                                      >
                                                        {
                                                          dish_list.dish_description
                                                        }
                                                      </div> */}
                                                      {/* {dish_list.dish_Calories ==
                                                        null ||
                                                      dish_list.dish_Calories ==
                                                        "" ? null : (
                                                        <div
                                                          className="des"
                                                          style={{
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          {
                                                            dish_list.dish_Calories
                                                          }{" "}
                                                          Kcal
                                                        </div>
                                                      )} */}
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                    </div>

                    <div id="Tuesday" className="tab-content ">
                      {counter_data
                        .filter((mydata) => mydata.name == "Tuesday")
                        .map((mydata) => {
                          const category_list = mydata.categories;
                          return (
                            <div className="text-left">
                              {category_list.map((supercat_name) => {
                                const sub_catategory =
                                  supercat_name.subcategories;

                                return (
                                  <div
                                    style={{
                                      // padding: "10px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <h1
                                      style={{
                                        color: "grey",
                                        textAlign: "center",
                                      }}
                                    >
                                      {supercat_name.supercatname}
                                    </h1>
                                    {sub_catategory.map((sub_cat) => {
                                      const dishes = sub_cat.category_dishes;
                                      return (
                                        <div
                                          style={{
                                            background: "#fff",
                                            // padding: "10px",
                                          }}
                                        >
                                          {sub_cat.subcatname == "NA" ? (
                                            <h3></h3>
                                          ) : (
                                            <h3 className="sub_cat_heading">
                                              {sub_cat.subcatname}
                                            </h3>
                                          )}
                                          <div className="container">
                                            <div className="row">
                                              {dishes
                                                .filter(
                                                  (dish_list) =>
                                                    dish_list.counter_heading ==
                                                    2,
                                                )
                                                .map((dish_list, index) => {
                                                  return (
                                                    <div
                                                      className="col-lg-6 col-md-6"
                                                      style={{
                                                        marginBottom: "20px",
                                                      }}
                                                    >
                                                      <div className="swin-sc products-01 style-04 light swin-vetical-slider">
                                                         

<div className="dish_row_wrap">
  {/* Row 1: veg/non-veg icon + dish name + indicators — always one line */}
  <div className="dish_main_row">
    <div className="dish_icon_fixed">
      {dish_list.dish_type == "Veg" ? (
        <img
          src="../assets/images/icon/vag.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      ) : (
        <img
          src="../assets/images/icon/non-vag-new.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      )}
    </div>

    <p
      className="dish_name dish_name_text"
      style={{
        marginRight: "5px",
        color: "black",
        fontWeight: "450",
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      {dish_list.dish_name}
    </p>

    <div className="dish_indicators_fixed">
      {dish_list.dish_indicator1 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator1}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator2 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator2}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator3 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator3}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
    </div>
  </div>

  {/* Price - stays top-right */}
  <p
    className="item-right dish_name text-center"
    style={{ marginBottom: "0px", flexShrink: 0 }}
  >
    {dish_list.dish_price == null ? null : (
      <span className="price woocommerce-Price-amount amount">
        ₹{dish_list.dish_price}
      </span>
    )}
  </p>

  {/* Row 2: kcal — goes below the name row (only wraps down on mobile) */}
  {(dish_list.dish_KiloCalories || dish_list.dish_ServingSize) && (
    <div className="dish_kcal_row">
      <div
        className="dish_kcal"
        style={{
          color: "#ffb300",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        (
        {dish_list.dish_KiloCalories && (
          <>{dish_list.dish_KiloCalories} Kcal</>
        )}
        {dish_list.dish_KiloCalories && dish_list.dish_ServingSize && " / "}
        {dish_list.dish_ServingSize && (
          <>
            {dish_list.dish_ServingSize}{" "}
            {dish_list.dish_ServedIn && dish_list.dish_ServedIn}
          </>
        )}
        )
      </div>
    </div>
  )}
</div>



                                                      </div>
                                                      {/* <div
                                                        className="des"
                                                        style={{
                                                          lineHeight: "0.1",
                                                        }}
                                                      >
                                                        {
                                                          dish_list.dish_description
                                                        }
                                                      </div> */}
                                                      {/* {dish_list.dish_Calories ==
                                                        null ||
                                                      dish_list.dish_Calories ==
                                                        "" ? null : (
                                                        <div
                                                          className="des"
                                                          style={{
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          {
                                                            dish_list.dish_Calories
                                                          }{" "}
                                                          Kcal
                                                        </div>
                                                      )} */}
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                    </div>

                    <div id="Wednesday" className="tab-content ">
                      {counter_data
                        .filter((mydata) => mydata.name == "Wednesday")
                        .map((mydata) => {
                          const category_list = mydata.categories;
                          return (
                            <div className="text-left">
                              {category_list.map((supercat_name) => {
                                const sub_catategory =
                                  supercat_name.subcategories;

                                return (
                                  <div
                                    style={{
                                      // padding: "10px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <h1
                                      style={{
                                        color: "gray",
                                        textAlign: "center",
                                      }}
                                    >
                                      {supercat_name.supercatname}
                                    </h1>
                                    {sub_catategory.map((sub_cat) => {
                                      const dishes = sub_cat.category_dishes;
                                      return (
                                        <div
                                          style={{
                                            background: "#fff",
                                            // padding: "10px",
                                          }}
                                        >
                                          {sub_cat.subcatname == "NA" ? (
                                            <h3></h3>
                                          ) : (
                                            <h3 className="sub_cat_heading">
                                              {sub_cat.subcatname}
                                            </h3>
                                          )}
                                          <div className="container">
                                            <div className="row">
                                              {dishes
                                                .filter(
                                                  (dish_list) =>
                                                    dish_list.counter_heading ==
                                                    3,
                                                )
                                                .map((dish_list, index) => {
                                                  return (
                                                    <div
                                                      className="col-lg-6 col-md-6"
                                                      style={{
                                                        marginBottom: "20px",
                                                      }}
                                                    >
                                                      <div className="swin-sc products-01 style-04 light swin-vetical-slider">
                                                          

<div className="dish_row_wrap">
  {/* Row 1: veg/non-veg icon + dish name + indicators — always one line */}
  <div className="dish_main_row">
    <div className="dish_icon_fixed">
      {dish_list.dish_type == "Veg" ? (
        <img
          src="../assets/images/icon/vag.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      ) : (
        <img
          src="../assets/images/icon/non-vag-new.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      )}
    </div>

    <p
      className="dish_name dish_name_text"
      style={{
        marginRight: "5px",
        color: "black",
        fontWeight: "450",
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      {dish_list.dish_name}
    </p>

    <div className="dish_indicators_fixed">
      {dish_list.dish_indicator1 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator1}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator2 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator2}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator3 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator3}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
    </div>
  </div>

  {/* Price - stays top-right */}
  <p
    className="item-right dish_name text-center"
    style={{ marginBottom: "0px", flexShrink: 0 }}
  >
    {dish_list.dish_price == null ? null : (
      <span className="price woocommerce-Price-amount amount">
        ₹{dish_list.dish_price}
      </span>
    )}
  </p>

  {/* Row 2: kcal — goes below the name row (only wraps down on mobile) */}
  {(dish_list.dish_KiloCalories || dish_list.dish_ServingSize) && (
    <div className="dish_kcal_row">
      <div
        className="dish_kcal"
        style={{
          color: "#ffb300",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        (
        {dish_list.dish_KiloCalories && (
          <>{dish_list.dish_KiloCalories} Kcal</>
        )}
        {dish_list.dish_KiloCalories && dish_list.dish_ServingSize && " / "}
        {dish_list.dish_ServingSize && (
          <>
            {dish_list.dish_ServingSize}{" "}
            {dish_list.dish_ServedIn && dish_list.dish_ServedIn}
          </>
        )}
        )
      </div>
    </div>
  )}
</div>


                                                      </div>
                                                      {/* <div
                                                        className="des"
                                                        style={{
                                                          lineHeight: "0.1",
                                                        }}
                                                      >
                                                        {
                                                          dish_list.dish_description
                                                        }
                                                      </div> */}
                                                      {/* {dish_list.dish_Calories ==
                                                        null ||
                                                      dish_list.dish_Calories ==
                                                        "" ? null : (
                                                        <div
                                                          className="des"
                                                          style={{
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          {
                                                            dish_list.dish_Calories
                                                          }{" "}
                                                          Kcal
                                                        </div>
                                                      )} */}
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                    </div>

                    <div id="Thursday" className="tab-content ">
                      {counter_data
                        .filter((mydata) => mydata.name == "Thursday")
                        .map((mydata) => {
                          const category_list = mydata.categories;
                          return (
                            <div className="text-left">
                              {category_list.map((supercat_name) => {
                                const sub_catategory =
                                  supercat_name.subcategories;

                                return (
                                  <div
                                    style={{
                                      // padding: "10px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <h1
                                      style={{
                                        color: "gray",
                                        textAlign: "center",
                                      }}
                                    >
                                      {supercat_name.supercatname}
                                    </h1>
                                    {sub_catategory.map((sub_cat) => {
                                      const dishes = sub_cat.category_dishes;
                                      return (
                                        <div
                                          style={{
                                            background: "#fff",
                                            // padding: "10px",
                                          }}
                                        >
                                          {sub_cat.subcatname == "NA" ? (
                                            <h3></h3>
                                          ) : (
                                            <h3 className="sub_cat_heading">
                                              {sub_cat.subcatname}
                                            </h3>
                                          )}
                                          <div className="container">
                                            <div className="row">
                                              {dishes
                                                .filter(
                                                  (dish_list) =>
                                                    dish_list.counter_heading ==
                                                    4,
                                                )
                                                .map((dish_list, index) => {
                                                  return (
                                                    <div
                                                      className="col-lg-6 col-md-6"
                                                      style={{
                                                        marginBottom: "20px",
                                                      }}
                                                    >
                                                      <div className="swin-sc products-01 style-04 light swin-vetical-slider">
                                                          
<div className="dish_row_wrap">
  {/* Row 1: veg/non-veg icon + dish name + indicators — always one line */}
  <div className="dish_main_row">
    <div className="dish_icon_fixed">
      {dish_list.dish_type == "Veg" ? (
        <img
          src="../assets/images/icon/vag.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      ) : (
        <img
          src="../assets/images/icon/non-vag-new.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      )}
    </div>

    <p
      className="dish_name dish_name_text"
      style={{
        marginRight: "5px",
        color: "black",
        fontWeight: "450",
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      {dish_list.dish_name}
    </p>

    <div className="dish_indicators_fixed">
      {dish_list.dish_indicator1 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator1}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator2 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator2}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator3 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator3}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
    </div>
  </div>

  {/* Price - stays top-right */}
  <p
    className="item-right dish_name text-center"
    style={{ marginBottom: "0px", flexShrink: 0 }}
  >
    {dish_list.dish_price == null ? null : (
      <span className="price woocommerce-Price-amount amount">
        ₹{dish_list.dish_price}
      </span>
    )}
  </p>

  {/* Row 2: kcal — goes below the name row (only wraps down on mobile) */}
  {(dish_list.dish_KiloCalories || dish_list.dish_ServingSize) && (
    <div className="dish_kcal_row">
      <div
        className="dish_kcal"
        style={{
          color: "#ffb300",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        (
        {dish_list.dish_KiloCalories && (
          <>{dish_list.dish_KiloCalories} Kcal</>
        )}
        {dish_list.dish_KiloCalories && dish_list.dish_ServingSize && " / "}
        {dish_list.dish_ServingSize && (
          <>
            {dish_list.dish_ServingSize}{" "}
            {dish_list.dish_ServedIn && dish_list.dish_ServedIn}
          </>
        )}
        )
      </div>
    </div>
  )}
</div>


                                                      </div>
                                                      {/* <div
                                                        className="des"
                                                        style={{
                                                          lineHeight: "0.1",
                                                        }}
                                                      >
                                                        {
                                                          dish_list.dish_description
                                                        }
                                                      </div> */}
                                                      {/* {dish_list.dish_Calories ==
                                                        null ||
                                                      dish_list.dish_Calories ==
                                                        "" ? null : (
                                                        <div
                                                          className="des"
                                                          style={{
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          {
                                                            dish_list.dish_Calories
                                                          }{" "}
                                                          Kcal
                                                        </div>
                                                      )} */}
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                    </div>

                    <div id="Friday" className="tab-content ">
                      {counter_data
                        .filter((mydata) => mydata.name == "Friday")
                        .map((mydata) => {
                          const category_list = mydata.categories;
                          return (
                            <div className="text-left">
                              {category_list.map((supercat_name) => {
                                const sub_catategory =
                                  supercat_name.subcategories;

                                return (
                                  <div
                                    style={{
                                      // padding: "10px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <h1
                                      style={{
                                        color: "gray",
                                        textAlign: "center",
                                      }}
                                    >
                                      {supercat_name.supercatname}
                                    </h1>
                                    {sub_catategory.map((sub_cat) => {
                                      const dishes = sub_cat.category_dishes;
                                      return (
                                        <div
                                          style={{
                                            background: "#fff",
                                            // padding: "10px",
                                          }}
                                        >
                                          {sub_cat.subcatname == "NA" ? (
                                            <h3></h3>
                                          ) : (
                                            <h3 className="sub_cat_heading">
                                              {sub_cat.subcatname}
                                            </h3>
                                          )}
                                          <div className="container">
                                            <div className="row">
                                              {dishes
                                                .filter(
                                                  (dish_list) =>
                                                    dish_list.counter_heading ==
                                                    5,
                                                )
                                                .map((dish_list, index) => {
                                                  return (
                                                    <div
                                                      className="col-lg-6 col-md-6"
                                                      style={{
                                                        marginBottom: "20px",
                                                      }}
                                                    >
                                                      <div className="swin-sc products-01 style-04 light swin-vetical-slider">
                                                         
<div className="dish_row_wrap">
  {/* Row 1: veg/non-veg icon + dish name + indicators — always one line */}
  <div className="dish_main_row">
    <div className="dish_icon_fixed">
      {dish_list.dish_type == "Veg" ? (
        <img
          src="../assets/images/icon/vag.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      ) : (
        <img
          src="../assets/images/icon/non-vag-new.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      )}
    </div>

    <p
      className="dish_name dish_name_text"
      style={{
        marginRight: "5px",
        color: "black",
        fontWeight: "450",
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      {dish_list.dish_name}
    </p>

    <div className="dish_indicators_fixed">
      {dish_list.dish_indicator1 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator1}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator2 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator2}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator3 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator3}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
    </div>
  </div>

  {/* Price - stays top-right */}
  <p
    className="item-right dish_name text-center"
    style={{ marginBottom: "0px", flexShrink: 0 }}
  >
    {dish_list.dish_price == null ? null : (
      <span className="price woocommerce-Price-amount amount">
        ₹{dish_list.dish_price}
      </span>
    )}
  </p>

  {/* Row 2: kcal — goes below the name row (only wraps down on mobile) */}
  {(dish_list.dish_KiloCalories || dish_list.dish_ServingSize) && (
    <div className="dish_kcal_row">
      <div
        className="dish_kcal"
        style={{
          color: "#ffb300",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        (
        {dish_list.dish_KiloCalories && (
          <>{dish_list.dish_KiloCalories} Kcal</>
        )}
        {dish_list.dish_KiloCalories && dish_list.dish_ServingSize && " / "}
        {dish_list.dish_ServingSize && (
          <>
            {dish_list.dish_ServingSize}{" "}
            {dish_list.dish_ServedIn && dish_list.dish_ServedIn}
          </>
        )}
        )
      </div>
    </div>
  )}
</div>

                                                      </div>
                                                      {/* <div
                                                        className="des"
                                                        style={{
                                                          lineHeight: "0.1",
                                                        }}
                                                      >
                                                        {
                                                          dish_list.dish_description
                                                        }
                                                      </div> */}
                                                      {/* {dish_list.dish_Calories ==
                                                        null ||
                                                      dish_list.dish_Calories ==
                                                        "" ? null : (
                                                        <div
                                                          className="des"
                                                          style={{
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          {
                                                            dish_list.dish_Calories
                                                          }{" "}
                                                          Kcal
                                                        </div>
                                                      )} */}
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                    </div>

                    <div id="Saturday" className="tab-content ">
                      {counter_data
                        .filter((mydata) => mydata.name == "Saturday")
                        .map((mydata) => {
                          const category_list = mydata.categories;
                          return (
                            <div className="text-left">
                              {category_list.map((supercat_name) => {
                                const sub_catategory =
                                  supercat_name.subcategories;

                                return (
                                  <div
                                    style={{
                                      // padding: "10px",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <h1
                                      style={{
                                        color: "gray",
                                        textAlign: "center",
                                      }}
                                    >
                                      {supercat_name.supercatname}
                                    </h1>
                                    {sub_catategory.map((sub_cat) => {
                                      const dishes = sub_cat.category_dishes;
                                      return (
                                        <div
                                          style={{
                                            background: "#fff",
                                            // padding: "10px",
                                          }}
                                        >
                                          {sub_cat.subcatname == "NA" ? (
                                            <h3></h3>
                                          ) : (
                                            <h3 className="sub_cat_heading">
                                              {sub_cat.subcatname}
                                            </h3>
                                          )}
                                          <div className="container">
                                            <div className="row">
                                              {dishes
                                                .filter(
                                                  (dish_list) =>
                                                    dish_list.counter_heading ==
                                                    6,
                                                )
                                                .map((dish_list, index) => {
                                                  return (
                                                    <div
                                                      className="col-lg-6 col-md-6"
                                                      style={{
                                                        marginBottom: "20px",
                                                      }}
                                                    >
                                                      <div className="swin-sc products-01 style-04 light swin-vetical-slider">
                                                        
<div className="dish_row_wrap">
  {/* Row 1: veg/non-veg icon + dish name + indicators — always one line */}
  <div className="dish_main_row">
    <div className="dish_icon_fixed">
      {dish_list.dish_type == "Veg" ? (
        <img
          src="../assets/images/icon/vag.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      ) : (
        <img
          src="../assets/images/icon/non-vag-new.png"
          className="dish_icon"
          style={{ marginRight: "5px" }}
        />
      )}
    </div>

    <p
      className="dish_name dish_name_text"
      style={{
        marginRight: "5px",
        color: "black",
        fontWeight: "450",
        fontSize: "16px",
        marginBottom: "0px",
      }}
    >
      {dish_list.dish_name}
    </p>

    <div className="dish_indicators_fixed">
      {dish_list.dish_indicator1 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator1}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator2 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator2}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
      {dish_list.dish_indicator3 == null ? null : (
        <img
          src={`${this.state.assets_url}/uploads/${dish_list.dish_indicator3}`}
          className="dish_icon"
          style={{ marginLeft: "5px", marginTop: "0px" }}
        />
      )}
    </div>
  </div>

  {/* Price - stays top-right */}
  <p
    className="item-right dish_name text-center"
    style={{ marginBottom: "0px", flexShrink: 0 }}
  >
    {dish_list.dish_price == null ? null : (
      <span className="price woocommerce-Price-amount amount">
        ₹{dish_list.dish_price}
      </span>
    )}
  </p>

  {/* Row 2: kcal — goes below the name row (only wraps down on mobile) */}
  {(dish_list.dish_KiloCalories || dish_list.dish_ServingSize) && (
    <div className="dish_kcal_row">
      <div
        className="dish_kcal"
        style={{
          color: "#ffb300",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        (
        {dish_list.dish_KiloCalories && (
          <>{dish_list.dish_KiloCalories} Kcal</>
        )}
        {dish_list.dish_KiloCalories && dish_list.dish_ServingSize && " / "}
        {dish_list.dish_ServingSize && (
          <>
            {dish_list.dish_ServingSize}{" "}
            {dish_list.dish_ServedIn && dish_list.dish_ServedIn}
          </>
        )}
        )
      </div>
    </div>
  )}
</div>                                                        

                                                      </div>
                                                      {/* <div
                                                        className="des"
                                                        style={{
                                                          lineHeight: "0.1",
                                                        }}
                                                      >
                                                        {
                                                          dish_list.dish_description
                                                        }
                                                      </div> */}
                                                      {/* {dish_list.dish_Calories ==
                                                        null ||
                                                      dish_list.dish_Calories ==
                                                        "" ? null : (
                                                        <div
                                                          className="des"
                                                          style={{
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          {
                                                            dish_list.dish_Calories
                                                          }{" "}
                                                          Kcal
                                                        </div>
                                                      )} */}
                                                    </div>
                                                  );
                                                })}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        )}
      </>
    );
  }
}

// Wrapper Component to Pass Params to Class Component
function CounterMenuWrapper() {
  const { id } = useParams();
  return <CounterMenu id={id} />;
}

export default CounterMenuWrapper;
